/**
 * Home Dry Containers Detail Formatter.
 * @param {*} value
 * @param {*} row
 * @returns {string}
 */
window.homeDryContainersDetailFormatter = function(value, row) {
    let html = "";
    html += '<table class="table text-nowrap">';
    html += '<thead>';
    html += '<tr>';
    html += '<td class="col-md-2">'+__('Humidity %')+'</td>';
    html += '<td class="col-md-2">'+__('Ambient °C')+'</td>';
    html += '<td>&nbsp;</td>';
    html += '</tr>';
    html += '</thead>';
    html += '<tbody>';
    html += '<tr>';
    const columns = ["humidity", "ambient"]
    columns.forEach(function (item) {
        html += '<td>';
        if (typeof row.logged_at[item] !== "undefined") {
            if (typeof row.outdated[item] !== "undefined"
                && parseInt(row.outdated[item], 10) === 1) {
                html += '<span class="fontawesome icon-history" style="margin-right: 6px"></span>';
                html += '<span style="color: #888 !important;">'+row.logged_at[item]+'</strong>';
            } else {
                html += row.logged_at[item];
            }
        } else {
            if (typeof row.outdated[item] !== "undefined"
                && parseInt(row.outdated[item], 10) === 1) {
                html += '<span class="fontawesome icon-history" style="margin-right: 6px"></span>';
                html += '-';
            } else {
                html += '-';
            }
        }
        html += '</td>';
    });
    html += '<td></td>';
    html += '</tr>';
    html += '</tbody>';
    html += '</table>';
    return html;
}
